import React from "react";

import { Block } from "@randajan/jet-react/dom/block";
import { Button } from "@randajan/jet-react/dom/form";
import { Locale } from "../../../../assets/Locale";

import "./MagicSuggest.scss";

export const MagicSuggest = (props)=>{
    const { onMagic, children } = props;
    const say = Locale.use();

    return (
        <Block level={0} className="MagicSuggest" caption={say("oauthMagicSuggestCaption")}>
            <p className="desc">{say("oauthMagicSuggestDesc")}</p>
            {children}
            <Button className="magic" onSubmit={onMagic}>{say("oauthMagicSuggestMagicButton")}</Button>
        </Block>
    );
};
